import { useExperimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery.ts';
import {
	stringifyPersonalizationAttributes,
	type PersonalizationAttribute,
} from '@confluence/legacy-schema-bridge/entry-points/stringifyPersonalizationAttributes.ts';

import type {
	ExcludeNewConfluenceActiveUserQuery as ExcludeNewConfluenceActiveUserQueryData,
	ExcludeNewConfluenceActiveUserQueryVariables,
} from './__types__/ExcludeNewConfluenceActiveUserQuery.ts';

export type UseExperimentalSiteUserPersonalizationParams = {
	variables: ExcludeNewConfluenceActiveUserQueryVariables;
	skip?: boolean;
};

export const useExperimentalSiteUserPersonalization = ({
	variables,
	skip,
}: UseExperimentalSiteUserPersonalizationParams) => {
	return useExperimentalQuery<
		ExcludeNewConfluenceActiveUserQueryData,
		ExcludeNewConfluenceActiveUserQueryVariables,
		{ attributes: PersonalizationAttribute[] | null }
	>({
		url: ({ cloudId, userId }) =>
			`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
		method: 'GET',
		variables,
		parseResult: (json): ExcludeNewConfluenceActiveUserQueryData => ({
			experimentalSiteUserPersonalization: {
				attributes: stringifyPersonalizationAttributes(json.attributes),
			},
		}),
		skip,
	});
};
